import { DeviceResolver } from '../maps/device_resolver';
import { CustomMapMarkersCollection } from '../maps/custom_marker';

class ClipperMap {
  constructor(mapElement, locations) {
    this.moveToExactLocation = this.moveToExactLocation.bind(this);
    this.moveToPlaceLocation = this.moveToPlaceLocation.bind(this);
    this.mapElement = mapElement;
    this.locations = locations;
    this.setMapDimensions(mapElement);
    this.map = new google.maps.Map(mapElement, {
      zoom: this.initialZoom(),
      center: this.initialLocation(),
      mapTypeControl: true,
      gestureHandling: 'greedy'
    });
    this.googleService = new google.maps.places.AutocompleteService();
    this.placeService = new google.maps.places.PlacesService(this.map);
    this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    this.initPostMapActions();
  }

  setMapDimensions(map) {
    if (DeviceResolver.desktopWidth() && !(DeviceResolver.isMobile())) {
      return;
    }
    const padding = document.querySelector('header').offsetHeight;
    map.style.paddingBottom = `calc(var(--vh, 1vh) * 100 - ${padding}px)`;
  }

  initPostMapActions() {
    this.markers = new CustomMapMarkersCollection(this.locations, this.map);
    google.maps.event.addListenerOnce(this.map, 'idle', () => this.mapLoadedCallback());
    this.map.addListener('bounds_changed', () => this.mapBoundaryChanged());
  }

  mapLoadedCallback() {
    if (this.mapSearch) {
      return;
    }
    this.updateLocationBasedOnPosition();
  }

  mapBoundaryChanged() {
    this.markers.showLocationsInBox(
      this.map.getBounds().getNorthEast().lat(),
      this.map.getBounds().getNorthEast().lng(),
      this.map.getBounds().getSouthWest().lat(),
      this.map.getBounds().getSouthWest().lng()
    );
  }

  centerToSearchedLocation() {
    const searchedText = document.getElementById('search')?.value || '';
    const exactLocation = this.containsBikeLinkLocation(searchedText);
    if (exactLocation !== null) {
      this.moveToExactLocation(exactLocation.id, exactLocation.latitude, exactLocation.longitude);
    } else {
      this.centerGoogleSearchedLocation(searchedText);
    }
  }

  containsBikeLinkLocation(searchedText) {
    const lowerSearchedText = searchedText.toLowerCase();
    return this.locations.find(location =>
      location.human_name.toLowerCase() === lowerSearchedText
    ) || null;
  }

  centerGoogleSearchedLocation(searchedText) {
    const googleParams = {
      input: searchedText,
      sessionToken: this.sessionToken,
      componentRestrictions: { country: 'us' }
    };
    this.googleService.getPlacePredictions(googleParams, (predictions, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        return;
      }
      this.placeService.getDetails(
        { placeId: predictions[0].place_id, fields: ['geometry'] },
        (place, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK) {
            return;
          }
          this.moveToPlaceLocation(place.geometry.location);
        }
      );
    });
  }

  moveToExactLocation(id, latitude, longitude) {
    this.map.setCenter(new google.maps.LatLng(latitude, longitude));
    this.map.setZoom(17);
    this.markers.activate(id);
  }

  moveToPlaceLocation(position) {
    this.map.setCenter(position);
    this.map.setZoom(17);
  }

  initialZoom() {
    if (this.locations.length === 1) {
      return 14;
    }
    return 4;
  }

  initialLocation() {
    if (this.locations.length === 1) {
      return { lat: this.locations[0].latitude, lng: this.locations[0].longitude };
    }
    return { lat: 40.922846, lng: -102.138878 };
  }

  updateLocationBasedOnPosition() {
    if (navigator.geolocation && (this.locations.length > 1)) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
        this.map.setZoom(8);
      });
    }
  }
}

export { ClipperMap };
